import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import {useState} from 'react'
import useAtmosphere from '~/hooks/useAtmosphere'
import useMutationProps from '~/hooks/useMutationProps'
import EmailPasswordResetMutation from '~/mutations/EmailPasswordResetMutation'
import {PALETTE} from '../styles/paletteV3'
import PlainButton from './PlainButton/PlainButton'





const ForgotButton = styled(PlainButton)({
  color: PALETTE.SKY_500,
  marginTop: '1rem'
})

const MessageSent = styled('div')({
  marginTop: '1rem',
  userSelect: 'none',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
})

const ForgotPasswordOneClick = (props) => {
  const {email} = props
  const [isSent, setIsSent] = useState(false)
  const {submitMutation, submitting, onCompleted} = useMutationProps()
  const atmosphere = useAtmosphere()
  const onClick = async () => {
    if (submitting) return
    submitMutation()
    EmailPasswordResetMutation(atmosphere, {email}, {})
    onCompleted()
    setIsSent(true)
  }

  if (isSent) {
    return (
      _jsxs(MessageSent, { children: [
        _jsxs('div', { children: ["Message sent to "   , email]})
        , _jsx('div', { children: "Check your inbox!"  })
      ]})
    )
  }
  return (
    _jsx(ForgotButton, { onClick: onClick, waiting: submitting, children: "Forgot your password?"

    })
  )
}

export default ForgotPasswordOneClick
